import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { getApp } from "../app";
import { InboxType } from "../state/state";
import { Alert } from "../../../../shared/types/alerts";

@Component({
  selector: "app-mail",
  templateUrl: "./mail.component.html",
  styleUrls: ["./mail.component.scss"],
})
export class MailComponent implements OnInit {
  mode: InboxType = "change";
  pcnId = "";
  showExport = false;
  url = "";

  app = getApp((app) => {
    this.app = app;
  });

  constructor(private _route: ActivatedRoute) {}

  public ngOnInit(): void {
    this.app.type = "mail";
    this.app.users.getAllUserNames();
    if (this._route.snapshot.firstChild != null) {
      this.pcnId = this._route.snapshot.firstChild.params["pcnId"];
      const data = this._route.snapshot.firstChild.data;
      if (data != null) {
        this.app.mail.tab = data.mode;
        this.mode = data.mode;
      }
      this.showExportBtn();
    }
    this.pcnURL();
  }

  showExportBtn() {
    if (
      this.mode === Alert.ALERT ||
      this.mode === Alert.CHANGEALERT ||
      this.mode === Alert.LEADTIMEALERT ||
      this.mode === Alert.INVENTORYMONITORINGALERT ||
      this.mode === Alert.ENVCOMPLIANCEALERT
    ) {
      this.showExport = true;
    }
  }

  routerLinkUrl(route: string) {
    return `/${this.app.customers.expectCurrent}/` + route;
  }

  pcnURL() {
    this.url = `https://app.lcm-client.com/${this.app.customers.expectCurrent}/pcn`;
    return this.url;
  }
}
